<script lang="ts">
  import { DotsThreeOutlineVertical, X, Upload } from "phosphor-svelte";
  import Notifications from "$components/notifications/Notifications.svelte";
  import Avatar from "$components/profile/Avatar.svelte";
  import { page } from "$app/stores";
  import {
    colors,
    activeColor,
    patronMenuDrawerOpen,
    menuDrawerOpen,
    scrollDisabled,
  } from "$lib/data";
  import { afterNavigate } from "$app/navigation";
  import UserMenu from "./UserMenu.svelte";
  import NotificationsList from "$components/notifications/NotificationsList.svelte";
  import { acceptingLateSubmissions, acceptingSubmissions } from "$lib/dates";
  import { fly } from "svelte/transition";
  import { onMount } from "svelte";

  let menu_open = false;
  let show_user_menu = false;
  let show_notifications_menu = false;
  let show_submit_menu = false;
  let nib_position: number = 15;
  const member_menu_toggle = () => {
    show_announcement = false;
    show_user_menu = false;
    show_notifications_menu = false;
    show_submit_menu = false;
    menu_open = false;
    $patronMenuDrawerOpen = !$patronMenuDrawerOpen;
    if ($menuDrawerOpen) {
      $menuDrawerOpen = false;
    }
  };
  $: $scrollDisabled = $patronMenuDrawerOpen || menu_open;

  const close_all = () => {
    menu_open = false;
    show_user_menu = false;
    show_notifications_menu = false;
    show_submit_menu = false;
    $patronMenuDrawerOpen = false;
  };

  afterNavigate(close_all);
  const toggle_user_menu = () => {
    $patronMenuDrawerOpen = false;
    nib_position = 16;
    show_announcement = false;
    show_submit_menu = false;
    show_notifications_menu = false;
    if (menu_open && show_user_menu) {
      menu_open = false;
      show_user_menu = false;
    } else if (menu_open && !show_user_menu) {
      show_user_menu = true;
    } else {
      menu_open = true;
      show_user_menu = true;
    }
  };

  const toggle_notifications_menu = () => {
    $patronMenuDrawerOpen = false;
    show_announcement = false;
    nib_position = 72;
    show_user_menu = false;
    show_submit_menu = false;
    if (menu_open && show_notifications_menu) {
      menu_open = false;
      show_notifications_menu = false;
    } else if (menu_open && !show_notifications_menu) {
      show_notifications_menu = true;
    } else {
      menu_open = true;
      show_notifications_menu = true;
    }
  };

  const toggle_submit_menu = () => {
    show_announcement = false;
    $patronMenuDrawerOpen = false;
    nib_position = 128;
    show_notifications_menu = false;
    show_user_menu = false;
    if (menu_open && show_submit_menu) {
      menu_open = false;
      show_submit_menu = false;
    } else if (menu_open && !show_submit_menu) {
      show_submit_menu = true;
    } else {
      menu_open = true;
      show_submit_menu = true;
    }
  };

  let y: number;
  $: show_announcement = y < 20 || announcement_timeout;
  let announcement_timeout: boolean = true;

  onMount(() => {
    setTimeout(async () => {
      announcement_timeout = false;
    }, 20000);
  });
</script>

<svelte:window bind:scrollY={y} />

<nav
  transition:fly={{ duration: 150, y: 15 }}
  style="
  --primary: {colors[$activeColor].color};
  --secondary: {colors[$activeColor].highlight};
"
>
  {#if show_announcement}
    <div class="announcement" transition:fly={{ duration: 200, x: 20 }}>
      MEMBER MENU
    </div>
  {/if}
  {#if menu_open}
    <div class="sub_menu" transition:fly={{ duration: 150, y: 15 }}>
      {#if show_user_menu}
        <UserMenu />
      {:else if show_notifications_menu}
        <NotificationsList />
      {:else}
        <div class="submit_menu">
          <a href="/members/contributions/"> My Contributions </a>
          <a href="/members/contributions/submit/bonus">
            Submit Bonus Contribution
          </a>
          <a href="/members/process-videos/submit"> Submit Process Video </a>
          {#if acceptingSubmissions || acceptingLateSubmissions}
            <a class="current" href="/members/contributions/submit/current">
              Submit to Episode #{$page.data.stats.total_episodes}
            </a>
          {/if}
        </div>
      {/if}

      <svg
        style="left: {nib_position}px"
        class="nib"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="20px"
        height="15px"
        viewBox="0 0 20 14.308"
        enable-background="new 0 0 20 14.308"
        xml:space="preserve"
      >
        <path
          fill="#FFFFFF"
          d="M20,15.712H0c0,0,8.394-13.702,8.999-14.308s1.37-0.631,2.002,0S20,15.712,20,15.712z"
        />
      </svg>
    </div>
  {/if}
  <button class="avatar" on:click={toggle_user_menu}>
    <Avatar user={$page.data.user} active={show_user_menu} />
  </button>
  <button class="avatar" on:click={toggle_notifications_menu}>
    <Notifications size={48} active={show_notifications_menu} />
  </button>
  <button
    class="submit"
    on:click={toggle_submit_menu}
    class:active={show_submit_menu}
  >
    <Upload size={22} />
  </button>
  <div class="menu">
    <button on:click={member_menu_toggle} class:active={$patronMenuDrawerOpen}>
      {#if $patronMenuDrawerOpen}
        <X size={22} />
      {:else}
        <DotsThreeOutlineVertical size={22} />
      {/if}
    </button>
  </div>
</nav>

{#if menu_open}
  <button class="backdrop" on:click={close_all} on:touchstart={close_all}
  ></button>
{/if}

<style>
  .announcement {
    position: absolute;
    bottom: 100%;
    color: white;
    background: var(--primary);
    padding: 0.5rem 1rem;
    border-radius: 0.5rem 0 0 0;
    right: 0;
    font-weight: bold;
    font-size: 0.75rem;
  }

  .backdrop {
    border: 0;
    background: rgba(31, 39, 45, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 6;
    padding: 0;
  }

  .nib {
    position: absolute;
    bottom: -14px;
    transform: rotate(180deg);
    transition: left 200ms ease-in-out;
    filter: drop-shadow(var(--shadow));
  }

  .submit_menu {
    font-size: 0.8rem;
    display: flex;
    flex-flow: column;
  }
  .submit_menu a {
    text-decoration: none;
    font-family: var(--font);
    color: var(--title);
    padding: 0.5rem;
  }
  .submit_menu .current {
    margin-top: 0.25rem;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    background: var(--secondary);
    font-weight: bold;
  }

  .sub_menu {
    position: absolute;
    bottom: calc(5rem + 4px);
    background: white;
    width: 80%;
    max-width: 300px;
    left: 10px;
    z-index: 20;
    box-shadow: var(--shadow);
    border-radius: 0.25rem;
    padding: 0.5rem;
  }

  nav {
    display: none;
  }
  @media (max-width: 1024px) {
    nav {
      display: flex;
      gap: 0.5rem;
      position: fixed;
      width: 100%;
      height: 5rem;
      background: white;
      z-index: 20;
      bottom: 0;
      left: 0;
      padding: 0.75rem;
      transition: transform 0.3s;
      box-shadow: var(--shadow);
    }
  }
  nav button {
    width: 3rem;
    height: 3rem;
    border: none;
    background: none;
    padding: 0;
  }
  nav .submit {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background: var(--offDark);
    color: white;
    font-size: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 4px solid white;
    box-shadow: var(--shadow);
    transition: all 200ms ease;
  }
  nav .submit.active {
    border-color: var(--secondary);
  }
  nav .menu {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
  nav .menu button {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background: var(--secondary);
    color: white;
    font-size: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 4px solid white;
    box-shadow: var(--shadow);
    transition: all 200ms ease;
  }
  nav .menu button.active {
    background: var(--primary);
    border-color: var(--secondary);
  }
</style>
